import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: localStorage.getItem('lang')||navigator.language ,
    fallbackLocale: 'ch',
    messages : {
        en: {
            website:'FHR CD Upload',
            hero: {
                title: 'Access your medical images anywhere with your mobile phone',
                upload: 'Upload your file',
                learn: 'Learn more',
            },
            form:{
                title1:'Please select a directory containing image files',
                title2:'The images will be sent to the',
                title22:'hospital, please wait... You need to apply to the hospital for the transfer of the external disc images before the images can be delivered to the hospital system',
                title3:'Please open the FHR APP in your phone, scan the QR code, and load the image file into your phone',
                hospital:'',
                fileupload:'File uploading... ',
                complete:'% complete',
                compress:'File compressing, please wait...',
                image:'Image transmission in the hospital',
                cancel:'Cancel',
                save: 'Save',
                upload:'Upload',
                name:'Name',
                age:'Age',
                sex: 'Sex',
                seq:'Sequence Number',
                exp:'Expire Day'
            },
            how:{
                title:'To view my medical images on mobile devices. How should I start?',
                subtitle:'First, you’ll need some medical image files, which normally can be found...',
                point1:'in Medical Imaging Discs from the hospital',
                point2:'on Your PC',
            },
            help:{
                title:'How medical images on mobile will',
                title2:'help',
                title3:' you?',
                subtitle1:'Access Anytime, Anywhere',
                subtitle2:'Manage Your images in One Place',
                subtitle3:'Second Opinion',
                point1:'browse or share images, even if you’re offline.',
                point2:'reduce the risks of Image loss',
                point3:'look for medical professionals’ opinions for diagnosis',
            },
            steps:{
                title1:'Carry the Images anywhere, anytime in',
                title2:' 4',
                title3:'steps',
                subtitle1:'Prepare for Medical Image files',
                subtitle2:'Upload your files',
                subtitle3:'Generate the QR Code',
                subtitle4:'Download Medical Images into your Mobile Devices',
                point1:'Make sure you have CDs or medical image files on your PC. If you have a CD, you can begin by inserting it into the disc driver.',
                point2:'*Note: Support for DICOM medical image format only (.DCM)',
                point3:'Click on the button to start selecting image files.',
                point4:'Make sure the internet is available on your PC, and start to upload your files. A QR Code will be generated after the upload is successful.',
                point5:'Open the FHR App, click on the “Scan” button, and scan the QR Code to start downloading your images.',
                point6:'*Note: Upload feature should use PC',
                upload:'Upload',
                first1:'For the first-time users',
                first2:'“FHR,” please scan the QR Code to install the application.',
                download:'Download FHR APP',
            },
            contact:{
                title:'Contact Us',
                subtitle:'To learn more, please leave us a message or visit our website',
                ebm:'(www.ebmtech.com).',
                info:'Leave your contact info',
                name:'Name*',
                email:'Email*',
                phone:'Phone Number',
                image:'Image uploading',
                message:'Message',
                submit:'Submit',
                success:'Form submitted successfully.',
            },
            footer:{
                rights:'All rights reserved.',
                terms:'Terms of use',
                privacy:'Privacy policy',
            },
            ude:{
                website:"UDE",
                about:'About Us',
                contact:'Contact',
                download:'Download',
                hero_header:'Server. Viewer. Display. AI. All in One iPad',
                signup:'Sign up for 2 months FREE trial',
                ude:'UDE',
                h1:'Comprehensive Viewing Tools',
                h2:'AI Gateway',
                h3:'Customizable Mammo Hanging Protocol',
                st1:'Provide users with an intuitive interface for an optimal viewing experience to satisfy the needs of radiologists and medical professionals as they view medical images on daily basis.',
                st2:'Enable both edge and cloud computing capabilities to visualize AI inference on images for aid in the diagnosis or detection for diseases.',
                st3:'Allow radiologists to identify and assess reliable breast cancer screening and outcomes through customizable hanging protocol settings.',
                update_h:'Easy Update',
                replace_h:'Easy Replacement',
                backup_h:'Easy Data Backup',
                update_st:'If the app requires update, you can simply update it through the Apple App Store.',
                replace_st:'If the device breaks down, you can simply replace it by getting a new iPad at any Apple authorized dealer.',
                backup_st:'All image data stored in UDE can be backed up to cloud-based servers or any compatible NAS.',
                better_h:'How is the UDE App better?',
                workflow:'The UDE App Workflow',
                mobility:'Mobility',
                flexibility:'Flexibility',
                computing:'Edge Computing',
                replacement:'Replacement Cost',
                setup:'Setup Cost',
                low:'Low',
                pacs:'PACS Workflow',
                unique:'What makes the UDE App unique?',
                calibration:'Calibration',
                ca_t:'The UDE App comes with an in-house designed calibration procedure that works with an external luminance meter manufactured by the third-party vendor. The calibration complies with the AAPM protocol and ensures any display of iPad Pro follows the DICOM Curve.',
                reporting:'Reporting System',
                re_t:'While traveling, doctors and medical professionals can complete their reports by using the AgileRIS, the app-based reporting system designed by EBM specifically for the UDE App. The reporting app connects with any Radiology Information System (RIS) to enable the ability for exam images and list of report to be pre-downloaded on the iPad. Both the images and the list are saved locally for offline access.',
                aiplatform:'AI-Ready Platform',
                a_t:'The UDE App supports both edge and cloud AI computing technologies, presenting the ability of incorporating imaging AI models in any type of format. Not only is the tablet-based DICOM viewer a great tool for making medical diagnosis, but it is the alternative of landing AI for developers/vendors. ',
                cdsolution:'CD-Less Solution',
                cd_t:'The UDE App changes the conventional referral procedure into a completely CD-less solution with DICOM image files being sent directly to mobile devices through either AirDrop (iOS only) or QR Code. The feature help facilitate the teleconsultation process between doctors and doctors while fulfilling the goal of reducing CD emissions.',
                certificate:'Certification & Awards',
                cert_t:'The UDE App displays images from CT, MR, CR, US, XA and SC for the trained physicians diagnosis or referring purpose. ',
                cert_st:'*The UDE App is not to be used for mammography diagnosis.',
                cert_t2:'Ubiquitous Diagnostic Environment (UDE) App has received numerous awards and recognition throughout the years, including the 2021 Edison Awards, the 2021 International Innovation Awards (IIA) and the 2021 National Innovation Awards.',
                explore:'Explore the potential of the UDE App',
                explore_t: 'We have seen the UDE app being used in various scenarios, helping medical professionals to stay efficient and to create more values. The UDE App is not intended to replace a full diagnostic workstation or system but to be a value-added option.',
                clinics:'Mobile Clinics',
                emergency:'Emergency',
                conference:'Conference',
                telemedicine:'Telemedicine',
                q1:'Ｑ1: With an iPad Pro, is there enough storage space to store images? How many images on average can be stored ?',
                a1:'A1:The internal storage is provided based on the hardware (iPad Pro) specifications. Currently, iPad Pros can support up to 1 TB storage; users can make the purchase based on their demands. Taking "Mammography (MG) images" as an example, users can store approximately 10,000 MG images based on the calculation of the formula (26MB/frames*4 frames/studies) on average.  *The number of images will vary based on the modality types and the storage occupied by OS and apps.',
                q2:'Q2: Could I use Samsung or other Android OS tablets instead of Apple iPads for the UDE app?',
                a2:'A2: Currently, the UDE App is only supported by iOS. Android support is still under development.',
                q3:'Q3: Is it reuqired to use iPad Pro for the UDE app?',
                a3:'A3: Yes. We suggest using iPad Pros for the UDE app since they are inherently designed with 5.6 MP image resolution.  Based on the industry standard, 5 MP image resolution is required to display MG images for diagnosis purposes.',
                q4:"Q4: What's the difference between the UDE app and the iDO Viewer app?",
                a4:'A4: The UDE app turns iPad Pro into a standalone DICOM server, viewer and display, meaning all DICOM image files are stored locally on the device, whereas iDO Viewer or other DICOM viewers generally require a connection with an external server. The UDE app allows access to the images completely offline, no delay.',
                q5:'Q5: How are images transfered between the UDE app and multiple modalities/PACS?',
                a5:'A5: The UDE app supports image transmission based on the DICOM 3.0 standard. Users only need to complete AE Title, Port, and IP settings on modalities/DICOM Server/PACS to enable DICOM communication with UDE.',
                q6:'Q6: The UDE app can support uploading images to the cloud for sharing purposes; should information security issues be considered?',
                a6:'A6: The UDE app not only encrypts image data for data protection but also uses SSL encryption procedures for image transmission. In addition, the encrypted symbols are added behind the downloading links ; thus, users are required to enter 4-digit verification codes to be able to download thier images.',
                q7:'Q7: How does the UDE app ensure patient privacy and data security?',
                a7:'A7: The UDE app inherently encrypts image data for data protection. Furthermore, the SSL encryption procedure is required when the app performs query/retrieves with PACS or multiple modalities via DICOM communication. EBM Technologies comply with the policies or rules relevant with information security and data protection, manage clinical data based on the data security principles from hospitals, and conduct a scan of all the data for systems regularly.',
                q8:'Q8: Inputting medical record numbers (MRNs) to query images is troublesome. Does the UDE app work with barcode scanner?',
                a8:'A8: Barcode scanner currently is not supported on the UDE app.',
                q9:'Q9: Can the UDE app be integrated with the hospita RIS, allowing radiologists to dictate reports?',
                a9:"A9: Unfortunately, the UDE app may not work with your original report system , but we've developed an offline-enabled reporting application---the AgileRIS app (integration with the hospital RIS is required) specifically for it. In the future, we are planning to develop a simple reporting system built in the UDE app.",
                q10:'Q10: Can users view images on the UDE App through their own laptop/PC?',
                a10:'A10: Currently, images can only be reviewed through the UDE App.',
                q11:"Q11: What's the price of the UDE App? Is it based on the number of licenses sold?",
                a11:'A11: The UDE app can be downloaded via the App Store for free and offer a subscription plans on a monthly basis for USD $29.99, or annual license for USD $10,000.',
                q12:'Q12: Currently, most people are still accustomed to using personal computers; how to change healthcare professionals habits of using PCs?',
                a12:'A12: The UDE app is intended to replace traditional workstations, but to provide doctors with on-the-go image browsing experiences even without internet access. Compared with other mobile DICOM viewer apps, the UDE app enables users to store images into iPad Pros and view images offline. Therefore, UDE is more efficient, convenient, and advantageous.',
                learnmore:'Learn More',
                showless:'Show Less',
                contact_h:'Leave your contact details to receive 2 months FREE trial!',
                sorry:'Sorry :(',
                sorry2:'The free trial event has concluded. If you would like more information, please contact us.',
                thankyou:'Thank you!',
                thankyou2:'Redeem the code on App Store to activate your free two-month trials.',
                promocode1:'your promotion code',
                promocode2:'*The promotion code is also sent to your email.',
                oops:'Oops!',
                oops2:'The email address you have entered is already used to sign up for this event and cannot be used again.',
                contact_us:"Contact us>"
            },
            helper:{
                website:'helper',
                header:'How to turn on AirDrop',
                header2:'Contact Us',
                address:' 5F, 516, Section 1, NeiHu Road. Taipei, Taiwan. 11493',
                service:'Service Center',
                sites:'Collaborative Sites',
                feedback:'Feedback',
                commonQuestions:'Common Questions',
                airdropQuestion:'How to turn on AirDrop?',
                hospitalQuestion:'Which hospitals can use FHR?',
                lineOfficial:'EBM Official LINE Account',
                addLineFriend:'Add LINE Friend',
                suggestions:'Suggest a Feature',
                fillFeedback:'Fill out usage feedback',
                currentVersion:'Current version'
            },
            epspi:{
                about:'About Us',
                contact:'Contact Us',
                download:'Download DM',
                contact_form:'Contact form'
            },
            questionnaire:{
                title:'Questionnaire List',
                refresh:'Refresh List',
                refreshing:'Refreshing...',
                loading:'Loading questionnaire list...',
                listRefreshed:'Questionnaire list refreshed successfully!',
                fetchError:'Failed to fetch questionnaire list. Please try again.',
                invalidResponse:"Invalid response from server",
                noRecords:"No questionnaire records found.",
                viewDetails:"View Details",
                detailsTitle:"Questionnaire Details",
                close:"Close",
                table:{
                    index:"Index",
                    createDate:"Create Date",
                    satisfaction:"Satisfaction",
                    feature:"Feature",
                    purpose:"Purpose",
                    device:"Device",
                    suggestion:"Suggestion",
                    name:"Name",
                    email:"Email",
                    telephone:"Telephone",
                    details:"Details"
                },
                features:{
                    option1:"Image Share/Receive",
                    option2:"Store CD Images",
                    option3:"View Exam Images",
                    option4:"Other",
                    option5:"Other"
                },
                purposes:{
                    option1:"Personal Health Maintenance",
                    option2:"Family Health Maintenance",
                    option3:"Patient Care Assistance",
                    option4:"Other",
                    option5:"Other"
                },
                devices:{
                    option1:"Mobile Phone",
                    option2:"Tablet",
                    option3:"Desktop",
                    option4:"Other",
                    option5:"Other"
                }
            }
        },
        ch: {
            website:'FHR光碟上傳',
            hero: {
                title: '光碟入手機 健康隨身走',
                upload: '上傳影像',
                learn: '了解更多',
            },
            form:{
                title1:'請選取含有影像檔之目錄',
                title2:'圖片將發送至',
                title22:'請稍候... 您需要向醫院申請轉移外部光盤映像，然後才能將映像傳送到醫院系統。',
                title3:'請開啟手機中之FHR APP，掃描QR code，將影像檔載入手機',
                hospital:'',
                fileupload:'檔案上傳中...',
                complete:'％完成',
                compress:'正在壓縮文件，請稍候...',
                image:'影像傳送醫院中',
                cancel:'取消',
                save: '儲存',
                upload:'上傳',
                name:'姓名',
                age:'年齡',
                sex: '性別',
                seq:'FHR影像下載序號',
                exp:'檔案下載期限'
            },
            how:{
            title:'想在手機上查看醫療影像。該如何開始？',
            subtitle:'首先，您需要有醫療影像檔案，通常會在...',
            point1:'醫院提供的醫療影像光碟中',
            point2:'您的電腦中',
            },
            help:{
            title:'用手機存放醫療影像有什麼',
            title2:'幫助',
            title3:'？',
            subtitle1:'需要時隨時瀏覽或分享',
            subtitle2:'集中管理，降低遺失風險',
            subtitle3:'尋求第二位專家建議',
            point1:'隨時瀏覽或分享影像，即使是在處於離線狀態。',
            point2:'影像病歷不再散落各地，降低遺失的風險',
            point3:'尋求醫療專業人士的診斷建議',
            },
            steps:{
            title1:'操作 ',
            title2:'四',
            title3:'步驟，影像帶著走',
            subtitle1:'準備好光碟 & 影像',
            subtitle2:'上傳檔案',
            subtitle3:'產生QR Code',
            subtitle4:'轉入手機',
            point1:'確保您的電腦有接光碟機或已有醫療影像檔案。如為光碟，請將其插入光碟機。',
            point2:'*注：僅支援標準 DICOM 醫療影像格式(.DCM)',
            point3:'點選「點此上傳」，選取影像檔案。',
            point4:'確認網路連線正常，開始上傳影像。上傳完成後，自動產生QR Code。',
            point5:'開啟手機中之FHR APP，點選“掃描下載”，讀取QR Code將影像傳入手機。',
            point6:'*註：上傳功能需使用電腦',
            upload:'點此上傳',
            first1:'初次使用FHR者，',
            first2:'請打開手機，掃描下面QR Code進行安裝。',
            download:'下載 FHR APP',
            },
            contact:{
                title:'聯繫我們',
                subtitle:'了解更多，請留言或瀏覽我們的網站',
                ebm:' www.ebmtech.com ',
                info:'留下您的聯絡方式',
                name:'姓名*',
                email:'電子郵件*',
                phone:'電話',
                image:'影像上傳',
                message:'訊息內容',
                submit:'送出',
                success:'表單送出成功。',
            },
            footer:{
            rights:'版權所有。',
            terms:'使用條款',
            privacy:'隱私政策',
            },
            ude:{
                website:"UDE",
                about:'關於我們',
                contact:'聯繫我們',
                download:'立即下載',
                hero_header:'Server. Viewer. Display. AI. All in One iPad',
                signup:'立即註冊即享有兩個月的免費試用',
                ude:'行動醫療影像伺服器',
                h1:'多重的影像瀏覽工具',
                h2:'AI 模組整合',
                h3:'客製化的乳房攝影掛片模式',
                st1:'提供使用者直覺簡單的操作瀏覽介面來滿足放射科醫師及專業醫療人員日常做影像判讀的需求。',
                st2:'運用邊緣運算及雲端運算技術來實現醫療影像 AI 輔助診斷的高效流程，透過病灶自動偵測來協助醫師做診斷',
                st3:'藉由可客製化的掛片模式設定，讓放射科醫師清楚瀏覽及判讀乳房攝影檢查的結果。',
                update_h:'簡易的App更新流程',
                replace_h:'簡易的替換流程',
                backup_h:'簡易的資料備份程序',
                update_st:'如需更新 UDE App，使用者能在 Apple App Store 上一鍵快速更新程式。',
                replace_st:'如平板裝置有損壞，使用者能向任何的Apple授權經銷商取得全新裝置做更換。',
                backup_st:'所有儲存於 UDE App 的影像檔案可備份到雲端伺服器空間或任何相容的網路儲存裝置(NAS)。',
                better_h:'為何 UDE App 為更好的解決方案?',
                workflow:'UDE App 流程',
                mobility:'可攜性',
                flexibility:'架構彈性',
                computing:'邊緣運算能力',
                replacement:'系統置換成本',
                setup:'系統建置成本',
                low:'Low',
                pacs:'PACS 系統流程',
                unique:'UDE App 獨特性?',
                calibration:'螢幕校正',
                ca_t:'UDE 整合自行開發設計的螢幕校準程序，可支援第三方製造商所提供的輝度計運作。此螢幕校準程序符合放射治療計量評估協議 (AAPM) 的標準，並確保iPad Pro亮度顯示符合DICOM Curve標準。',
                reporting:'報告系統',
                re_t:'AgileRIS 是以 iPad 為硬體設備，可離線作業的放射科報告 App，滿足醫師及醫療人士在院外、會議或旅行途中撰寫報告的需求。AgileRIS 可搭配 UDE App，將院內檢查影像及報告清單預先載入平板裝置，在無網路環境下也可即時調閱。',
                aiplatform:'AI 落地平台',
                a_t:'UDE App 同時支援邊緣和雲端運算技術，可與多格式的影像病灶偵測 AI 模型做整合。以平板作為平台的 DICOM 影像系統不僅是作為醫學診斷的工具，更是 AI 團隊及開發廠商 AI 落地的絕佳替代方案。',
                cdsolution:'光碟片燒錄的替代方案',
                cd_t:'將傳統的轉院程序轉換為無光碟片的解決方案；使用者能藉由 AirDrop (只限 iOS 系統)及 QR code 掃描將標準 DICOM 影像檔直接傳送至個人行動裝置做保存及瀏覽。此功能也適用於醫師之間的遠距會診，並減少光碟片的使用。',
                certificate:'品質認證及獎項',
                cert_t:'The UDE App 能顯示從儀器端傳送的 CT, MR, CR, US, XA 及 SC 影像，以利醫師判讀及診斷病徵。',
                cert_st:'*The UDE App 無法作為乳房攝影影像的診斷工具。',
                cert_t2:'UDE App 近幾年已獲得無數的獎項及認可，其中包含 2021年美國艾迪生獎ˋ2021年國際新創獎及 2021年國家新創獎。',
                explore:'挖掘 UDE App 更多的可能',
                explore_t: 'UDE App 可適用的多種不同的情境流程，協助醫師在日常工作流程上能更有效率，創造更高價值。App 的角色不是取代醫院內現有的工作站，而是作為行動化及無網路環境下的加值方案。',
                clinics:'醫療巡檢車',
                emergency:'急診使用',
                conference:'會議模式',
                telemedicine:'遠程醫療',
                q1:'Q1: 儲存空間會不會不夠？可以存多少影像？',
                a1:'A1: 儲存空間是參照硬體本身(iPad Pro)規格所提供, iPad Pro目前支援最多1TB儲存空間, 使用者可依照自己的使用需求做購買. 以MG影像作為範例, 平均26MB/張*4張/筆檢查計算, 可存取約10,000筆MG檢查. *數量因影像類型, iOS和App佔的空間會略有不同.',
                q2:'Q2: 一定要用iPad嗎？我現有的平板可以使用嗎？如Samsung, Android等作業系統規格也不差。',
                a2:'A2: 目前UDE僅支援iOS作業系統. Android系統在開發中. ',
                q3:'Q3: iPad一定要用到Pro的等級嗎?',
                a3:'A3: 是的, 會建議使用iPad Pro, 因為具備高達5.6MP的解析度. 對應於診斷MG所使用的螢幕, 一般也要求至少要5MP的解析度.',
                q4:"Q4: 和ebm 的 ido viewer有什麼不同？",
                a4:'A4: UDE是以iPad作為影像儲存核心的App, 可在完全離線的狀態下做影像瀏覽, 即時調閱, 無延遲. ',
                q5:'Q5: 儀器/PACS與UDE之間是如何做影像傳輸?',
                a5:'A5: UDE支援標準DICOM3.0影像傳輸, 僅需在儀器/DICOM Server上完成AE Title, Port, IP設定, 就能與UDE做通訊. ',
                q6:'Q6: UDE支援影像上傳雲端分享，資安上是否有疑慮 ?',
                a6:'A6: 資料在APP本體除了有進行加密保護，傳輸過程中也使用SSL加密方式, 並在下載路徑添增加密字符串. 使用者需敲入4位驗證碼才能下載. ',
                q7:'Q7: UDE如何確保病患隱私及資料安全？',
                a7:'A7: 在APP本體也有對資料本身進行加密保護，並當與DICOM Server或儀器通訊時，也使用SSL加密方式進行加密，達到傳輸時資料保護效果.',
                q8:'Q8: 查找影像輸入病歷號麻煩，是否有支援條碼掃描?',
                a8:'A8: 暫時無支援.',
                q9:'Q9: 可否搭配原有的系統打報告 ?',
                a9:"A9: 暫時無法搭配原有的報告系統. 不過商之器有針對UDE開發相應的報告系統: AgileRIS (需整合院內RIS), 接下來也規劃UDE本身的簡易報告系統. ",
                q10:'Q10: 可不可以用電腦看?',
                a10:'A10: 目前僅支援透過其他UDE做影像調閱/瀏覽.',
                q11:"Q11:UDE整體售價以何種方式銷售？",
                a11:'A11: UDE是純軟體做販售, 可透過App Store免費下載, 並以$29.99美金訂閱(月租)方式購買,或$10,000美金年繳授權方式.',
                q12:'Q12: 目前大部分的人還是習慣PC作業，如何改變醫護人員習慣操作?',
                a12:'A12: UDE主要並不是取代工作站PC角色, 而是作為醫生在移動, 居家甚至是無網路環境更佳的替代方案. 對比市面上常見的手機,平板viewer, UDE將影像儲存於平板, 並可離線做影像調閱, 更具優勢,及方便性.',
                learnmore:'更多',
                showless:'收起',
                contact_h:'立即索取兩個月免費試用！',
                sorry:'很遺憾 :(',
                sorry2:'免費試用活動已經結束. 如需更多資訊, 請聯繫我們. ',
                thankyou:'謝謝您!',
                thankyou2:'請透過App Store啟用您的UDE兩個月免費試用代碼',
                promocode1:'您的促銷代碼',
                promocode2:'促銷代碼已寄送到您的Email地址.',
                oops:'抱歉 :(',
                oops2:'該Email地址已被註冊. 如未收到信件, 請聯繫我們: info@ebmtech.com',
                contact_us:"联系我们"
            },
            helper:{
                website:'helper',
                header:'如何開啟Airdrop?',
                header2:'客服資訊',
                address:'11493台北市內湖路一段516號5樓',
                service:'EBM TECHNOLOGIES INC',
                sites:'推廣醫院',
                feedback:'使用回饋',
                commonQuestions:'常見問題',
                airdropQuestion:'如何開啟AirDrop?',
                hospitalQuestion:'FHR 可在哪些醫院使用?',
                lineOfficial:'EBM LINE 官方帳號',
                addLineFriend:'加入LINE好友',
                suggestions:'對FHR 有建議嗎?',
                fillFeedback:'填寫使用回饋',
                currentVersion:'目前版本'
            },
            epspi:{
                about:'關於我們',
                contact:'聯絡我們',
                download:'下載DM',
                contact_form:'聯絡表單'
            },
            questionnaire:{
                title:'問卷調查列表',
                refresh:'重新整理列表',
                refreshing:'重新整理中...',
                loading:'載入問卷調查列表...',
                listRefreshed:'問卷調查列表重新整理成功！',
                fetchError:'獲取問卷調查列表失敗。請再試一次。',
                invalidResponse:"伺服器回應無效",
                noRecords:"找不到問卷調查記錄。",
                viewDetails:"查看詳細資料",
                detailsTitle:"問卷調查詳細資料",
                close:"關閉",
                table:{
                    index:"索引",
                    createDate:"建立日期",
                    satisfaction:"滿意度",
                    feature:"功能",
                    purpose:"用途",
                    device:"裝置",
                    suggestion:"建議",
                    name:"姓名",
                    email:"電子郵件",
                    telephone:"電話",
                    details:"詳細資料"
                },
                features:{
                    option1:"影像分享/接收",
                    option2:"儲存CD光碟影像",
                    option3:"檢查影像瀏覽",
                    option4:"其他",
                    option5:"其他"
                },
                purposes:{
                    option1:"自身健康維護",
                    option2:"家人健康維護",
                    option3:"病人診療協助",
                    option4:"其他",
                    option5:"其他"
                },
                devices:{
                    option1:"手機",
                    option2:"平板",
                    option3:"電腦",
                    option4:"其他",
                    option5:"其他"
                }
            }
        },
        vn:{
            ude:{
                website:"UDE",
                about:'Giới thiệu công ty',
                contact:'Liên hệ',
                download:'Tải về',
                hero_header:'Máy chủ. Màn hình. Trình ảnh. AI. Chỉ trong một iPad',
                signup:'Đăng kí và nhận ngay 2 tháng dùng thử miễn phí',
                ude:'UDE',
                h1:'Trình duyệt ảnh đa tính năng',
                h2:'AI Gateway',
                h3:'Tuỳ chỉnh phương thức treo nhũ ảnh',
                st1:'Giao diện trình duyệt ảnh trực quan, thao tác đơn giản giúp người dùng trải nghiệm tối ưu và thoả mãn nhu cầu của các bác sĩ, hỗ trợ công việc chẩn đoán hình ảnh hàng ngày.',
                st2:'Tích hợp công nghệ AI với cả hai điện toán biên và đám mây để phân tích và hỗ trợ chẩn đoán hình ảnh hoặc phát hiện bệnh.',
                st3:'Cho phép bác sĩ xác định và đánh giá tin cậy hơn khi đánh giá kết quả và tầm soát ung thư vú thông qua điều chỉnh cài đặt phương thức treo nhũ ảnh',
                update_h:'Dễ dàng cập nhật',
                replace_h:'Dễ dàng thay thế',
                backup_h:'Dễ dàng sao lưu dữ liệu',
                update_st:'Khi nhận thông báo cập nhật, người dùng có thể cập nhật ứng dụng trên Apple App Store.',
                replace_st:'Khi thiết bị gặp sự cố, người dùng có thể thay thế một iPad mới tại bất kì đại lý uỷ quyền sản phẩm Apple.',
                backup_st:'Tất cả tệp hình ảnh được lưu trong UDE có thể sao lưu vào máy chủ kết nối đám mây hoặc hệ thống lưu trữ NAS.',
                better_h:'Những lợi thế của ứng dụng UDE là gì?',
                workflow:'Trạm làm việc với ứng dụng UDE',
                mobility:'Năng động',
                flexibility:'Linh hoạt',
                computing:'Công nghệ điện toán biên',
                replacement:'Chi phí thay thế hệ thống',
                setup:'Giá thành hệ thống',
                low:'Thấp',
                pacs:'Trạm làm việc với hệ thống PACS',
                unique:'Những ưu điểm nổi bật của ứng dụng UDE?',
                calibration:'Hiệu chuẩn màn hình',
                ca_t:'Ứng dụng UDE được tích hợp chương trình hiệu chuẩn với thiết bị đo độ chói từ nhà sản xuất bên thứ ba cung cấp. Việc hiệu chuẩn tuân thủ quy trình đánh giá đo lường xạ trị (AAPM) và đảm bảo mọi màn hình của iPad Pro đều đạt tiêu chuẩn DICOM Curve.',
                reporting:'Hệ thống báo cáo',
                re_t:'Khi đi du lịch, các bác sĩ và chuyên gia y tế có thể hoàn thành báo cáo nhờ ứng dụng AgileRIS, là hệ thống báo cáo được EBM đặc biệt thiết kế cho ứng dụng UDE. Với ứng dụng AgileRIS, kết nối với bất kì hệ thống (RIS) nào  để tải trước hình ảnh xét nghiệm, danh sách báo cáo và lưu trữ trên iPad, nhờ đó có thể truy cập theo thời gian thực khi không có kết nối mạng. ',
                aiplatform:'Nền tảng tích hợp sẵn AI',
                a_t:'Ứng dụng UDE đồng thời hỗ trợ đa dạng ảnh với công nghệ AI điện toán biên và đám mây, phát hiện tổn thương khi phân tích hình ảnh. Phát triển ứng dụng trên máy tính bảng đạt tiêu chuẩn DICOM không chỉ tăng độ linh hoạt trong việc chẩn đoán y tế mà còn là một công cụ thay thế tuyệt vời với nền tảng AI cho các nhà phát triển / nhà cung cấp khác.',
                cdsolution:'Giải pháp lưu trữ dữ liệu số',
                cd_t:'So với quy trình chuyển viện trước đây, ứng dụng UDE giúp hạn chế sử dụng đĩa CD; người dùng có thể sử dụng Airdrop (chỉ dành cho iOS) hoặc quét mã QR để lưu trữ tệp hình ảnh DICOM đến thiết bị di động cá nhân. Tính năng này cũng thích hợp cho các cuộc hội chẩn trực tuyến.',
                certificate:'Chứng nhận và giải thưởng',
                cert_t:'Ứng dụng UDE hiển thị hình ảnh từ CT, MR, CR, US, XA và SC thuận tiện cho các bác sĩ trong việc chẩn đoán các triệu chứng. ',
                cert_st:'* Ứng dụng UDE không được sử dụng để chẩn đoán chụp nhũ ảnh.',
                cert_t2:'Ứng dụng Ubiquitous Diagnostic Environment (UDE) đã nhận được nhiều giải thưởng và sự công nhận trong những năm gần đây, bao gồm Giải thưởng Addison của Mỹ năm 2021, Giải thưởng Sáng tạo Quốc tế năm 2021 (IIA) và Giải thưởng Sáng tạo Quốc gia năm 2021.',
                explore:'Mô hình tiềm năng ứng dụng UDE trong thực tiễn',
                explore_t: 'Ứng dụng UDE có thể được áp dụng cho các tình huống khác nhau, giúp các bác sĩ làm việc hiệu quả và tạo ra nhiều giá trị hơn. Vai trò của ứng dụng UDE không nhằm thay thế hệ thống hoặc trạm chẩn đoán truyền thống mà là một giải pháp giá trị gia tăng trong môi trường di động và không có mạng.',
                clinics:'Xe khám bệnh lưu động',
                emergency:'Cấp cứu',
                conference:'Báo cáo hội nghị',
                telemedicine:'Hội chẩn trực tuyến',
                q1:'Ｑ1: Với iPad Pro, có đủ dung lượng lưu trữ để lưu trữ hình ảnh không? Trung bình có thể lưu được bao nhiêu hình ảnh?',
                a1:'A1: Bộ nhớ trong được cung cấp dựa trên thông số kỹ thuật phần cứng (iPad Pro). Hiện tại, iPad Pro có thể hỗ trợ bộ nhớ lên đến 1 TB; người dùng có thể lựa chọn phù hợp nhu cầu sử dụng. Lấy hình nhũ ảnh (MG) làm ví dụ, người dùng có thể lưu trữ khoảng 10.000 hình ảnh MG theo phép tính như sau (trung bình 26MB / khung hình * 4 khung hình / 1 xét nghiệm). * Số lượng hình ảnh sẽ thay đổi tùy theo loại thiết bị chẩn đoán và dung lượng lưu trữ của hệ điều hành và ứng dụng.',
                q2:'Q2: Tôi có thể sử dụng Samsung hoặc máy tính bảng hệ điều hành Android khác thay vì Apple iPad cho ứng dụng UDE không?',
                a2:'A2: Hiện tại, ứng dụng UDE chỉ hỗ trợ hệ điều hành iOS, hệ điều hành Android vẫn đang được phát triển',
                q3:'Q3: Có nhất thiết sử dụng ứng dụng UDE trên phiên bản iPad Pro không?',
                a3:'A3: Có, nên dùng iPad Pro, vì vốn được thiết kế với độ phân giải hình ảnh 5.6 MP. Theo tiêu chuẩn ngành công nghiệp, khuyến nghị dụng độ phân giải hình ảnh ít nhất 5 MP trong chẩn đoán nhũ ảnh (MG).',
                q4:"Q4: Sự khác biệt giữa ứng dụng UDE và ứng dụng iDO Viewer là gì?",
                a4:'A4: Ứng dụng UDE biến iPad Pro thành một máy chủ, trình ảnh và hiển thị hình ảnh DICOM độc lập, có nghĩa là tất cả các tệp hình ảnh DICOM được lưu trữ trực tiếp trên thiết bị, trong khi iDO Viewer hoặc các trình duyệt ảnh DICOM khác thường yêu cầu kết nối với hệ thống máy chủ. Ứng dụng UDE cho phép truy cập ở trạng thái ngoại tuyến và đọc hình ảnh trong thời gian thực mà không bị chậm trễ.',
                q5:'Q5: Làm thế nào hình ảnh được truyền từ ứng dụng UDE và các thiết bị chẩn đoán hình ảnh/PACS?',
                a5:'A5: Ứng dụng UDE hỗ trợ truyền hình ảnh tiêu chuẩn DICOM 3.0. Người dùng chỉ cần hoàn thành cài đặt AE, Port, IP trên thiết bị/Máy chủ DICOM/PACS, sau đó có thể kết nối với UDE.',
                q6:'Q6: Tính năng hỗ trợ chia sẽ hình ảnh qua hệ thống dữ liệu đám mây của ứng dụng UDE, có đáng lo ngại về độ bảo mật thông tin không?',
                a6:'A6: Bản chất ứng dụng UDE, ngoài tính năng bảo vệ mã hoá dữ liệu hình ảnh mà còn sử dụng mã hoá SSL trong quá trình truyền hình ảnh. Ngoài ra, chuỗi mật khẩu được thêm vào đường dẫn tải xuống, người dùng cần nhập mã xác minh 4 chữ số để tiếp tục tải xuống.',
                q7:'Q7: UDE đảm bảo quyền riêng tư của bệnh nhân và bảo mật dữ liệu như thế nào?',
                a7:'A7: Trong ứng dụng UDE có thể tự mã hoá dữ liệu nhằm bảo mật dữ liệu hình ảnh. Hơn nữa, quy trình mã hoá SSL luôn được kích hoạt khi kết nối với PACS hoặc thiết bị chẩn đoán thông qua tiêu chuẩn DICOM. Công ty EBM luôn tuân thủ các chính sách, quy tắc liên quan đến bảo mật thông tin, quản lý dữ liệu lâm sàng của bệnh viện và tiến hành quét tất cả dữ liệu cho hệ thống thường xuyên.',
                q8:'Q8: Có thể áp dụng mã QR trong tìm kiếm hồ sơ bệnh án (MRNs) không? ',
                a8:'A8: Tạm thời chưa hỗ trợ tính năng này.',
                q9:'Q9: Có thể thực hiện báo cáo trực tiếp trên ứng dụng UDE không?',
                a9:"A9: Ứng dụng UDE không trực tiếp thực hiện báo cáo. Tuy nhiên, công ty EBM đã phát triển một ứng dụng tích hợp với UDE: AgileRIS (cần tích hợp RIS trong bệnh viện). Trong thời gian sớm nhất, chúng tôi sẽ phát triển hệ thống báo cáo dùng trên ứng dụng UDE.",
                q10:'Q10: Có thể sử dụng máy tính để xem hình ảnh từ ứng dụng UDE không?',
                a10:'A10: Hiện tại chỉ hỗ trợ truy vấn hoặc xem hình ảnh trên ứng dụng UDE hoặc thông qua các ứng dụng khác tương thích định dạng DICOM.',
                q11:"Q11: Chi phí tổng thể của UDE được bán như thế nào?",
                a11:' A11: UDE là phần mềm có thể tải miễn phí trên App Store và mua gói theo tháng với giá 29.99 USD, hoặc thanh toán một lần duy nhất với giá 10,000 USD.',
                q12:'Q12: Làm sao để thay đổi thói quen của nhân viên y tế, hầu hết mọi người vẫn quen với việc vận hành bằng máy tính?',
                a12:'A12: UDE không thay thế vai trò của máy tính mà là một giải pháp thay thế khi các bác sĩ đang di chuyển, tại nhà hoặc thậm chí không có kết nối Internet. So với các thiết bị điện thoại di động và máy tính bảng thông thường trên thị trường, UDE có thể lưu trữ hình ảnh trên máy tính bảng và có thể xem hình ảnh ngoại tuyến là những ưu điểm và tiện lợi hơn.',
                learnmore:'Xem thêm',
                showless:'Rút gọn',
                contact_h:'Hãy để lại thông tin liên lạc và nhận ngay 2 tháng dùng thử miễn phí!',
                sorry:'Rất tiếc :(',
                sorry2:'Thời hạn dùng thử miễn phí đã kết thúc. Tìm hiểu thêm thông tin, vui lòng liên hệ với chúng tôi.',
                thankyou:'Cảm ơn đã đăng kí!',
                thankyou2:'Vui lòng kích hoạt mã ưu đãi dùng thử miễn phí hai tháng khi tải ứng dụng trên App Store.',
                promocode1:'Mã ưu đãi',
                promocode2:' Mã ưu đãi cũng được gửi đến địa chỉ email của bạn.',
                oops:'Xin lỗi :(',
                oops2:'Địa chỉ email này đã được đăng ký, nếu bạn chưa nhận được thư xác nhận mã ưu đãi, vui lòng liên hệ với chúng tôi.',
                contact_us:"liên hệ chúng tôi>"
            }
        }
    }
})